import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

// Modified from https://medium.com/@juannegrin/boosting-your-angular-app-performance-with-caching-a-beginners-guide-768b93284000 
export class CacheService {

    private cache = new Map<CacheKey, any>();
    public cache$ = new BehaviorSubject<any>(null);

    set(key: CacheKey, data: any): void {
        let prevoiusCache = this.cache.get(key);
        this.cache.set(key, data);

        // Update the BehaviorSubject if the data is changed, then trigger the subscriber
        if (prevoiusCache != data) {
            this.cache$.next(this.cache.get(key));
        }
    }

    get(key: CacheKey): any {
        const data = this.cache.get(key);
        return data;
    }

    clear(key: CacheKey): void {
        this.cache.delete(key);
        this.cache$.next(null);
    }
}

export enum CacheKey {
    PFM_TIPS = "PFM_TIPS"
}

